﻿window.reCaptchaCallback = function (response) {
    var recaptchaResponse = grecaptcha.getResponse();
    if (recaptchaResponse.length != 0) {
        $('.googleRecaptchaClass').val(recaptchaResponse);
    }
};



export default class GooogleRecaptcha {
    constructor() {
        this.dom = {
            $: window.$
        };
        this.init();
    }
    init() {
        //this.setCaptchaValueOnSubmitClick();
        this.validateCaptcha();
    }

    validateCaptcha() {
        var that = this;
        var keys = { "keys": ["CAPTCHA_REQUIRED"] };
        getAjaxData("/api/sitecore/validations/GetValidationMessages", "POST", false, keys, function (data) {
            if (data) {
                $.validator.addMethod('validateCheckCaptcha', function (value, element) {
                    return that.verifyCaptcha();
                }, data["CAPTCHA_REQUIRED"]);

                $.validator.addClassRules('googleRecaptchaClass', { validateCheckCaptcha: true });
            }
        });
    }

    verifyCaptcha() {
        if ($('.div-recaptcha-id').css('visibility') == 'collapse') {
            return true;
        }
        var response = $('.googleRecaptchaClass').val().trim();
        
        var isValid = response.length > 0 ? true:false;
        ////resetCaptchaOTPCounter();
        return isValid;
    }

    //setCaptchaValueOnSubmitClick() {
    //    $('.recaptcha').click(function (e) {
    //        var recaptchaResponse = grecaptcha.getResponse();
    //        //cLog(recaptchaResponse);
    //        //cLog(recaptchaResponse.length);
    //        if (recaptchaResponse.length != 0) {
    //            $('.googleRecaptchaClass').val(recaptchaResponse);
    //            ////resetCaptchaOTPCounter();
    //        }
    //    });
    //}
}

document.addEventListener('DOMContentLoaded', () => new GooogleRecaptcha());
